import React from "react";
import moment from "moment";
import Cookies from 'universal-cookie';
import Utils from "../utils/utils";

// components
import PageTitle from "../components/PageTitle/PageTitle";
import Table from '../widgets/tables/Table';
import Loading from "../components/Loading";
import checkToken from "../services/checkToken";

// apis
import getOrdini from "../services/getOrdini";
import getOrdiniTecnico from "../services/getOrdiniTecnico";
import editOrdineCsVisione from "../services/editOrdineCsVisione";
import deleteOrdine from "../services/deleteOrdine";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });
export default class Ordini extends React.Component {

  constructor(props) {
    super(props)

    this.headCells = [
      { id: 'rif', numeric: false, disablePadding: true, label: 'Rif' },
      { id: 'ragione_sociale', numeric: true, disablePadding: false, label: 'Cliente' },
      { id: 'data_pronto', numeric: true, disablePadding: false, label: 'Data Pronto' },
      { id: 'data_consegna', numeric: true, disablePadding: false, label: 'Data Consegna' },
      { id: 'totale_ordine', numeric: true, disablePadding: false, label: 'Totale' },
      { id: 'stato', numeric: true, disablePadding: false, label: 'Stato', chip: true }
    ];

    this.state = {
      isLoading: true
    };

  }

  async reload() {
    this.setState({ isLoading: true });

    username = cookies.get('username', { path: '/' });
    token = cookies.get('token', { path: '/' });

    const check = await checkToken(username, token, true);
    const userType = parseInt(check.utente.tipo);
    let OrdineLink = '';

    userType === 1 ? this.ordini = await getOrdiniTecnico(username, token) : this.ordini = await getOrdini(username, token);


    if (userType === 0) {

      var dates = [];
      let ordiniMensiliSomma = [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0];
      let ordiniFatturatoSomma = [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0];
      let ordiniUsciteSomma = [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0];
      let ordiniEntrateSomma = [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0];

      let currDate = '01/01/' + moment().format('yyyy');
      let endDate = '01/01/' + moment().add(1, 'year').format('yyyy');

      while (currDate.substring(currDate.length, 6) !== endDate.substring(endDate.length, 6)) {
        let data = moment(currDate, 'DD/MM/yyyy').format('MMMM yy');
        dates.push({ id: data.replace(' ', '_'), numeric: false, disablePadding: false, label: data, largeView: true, filter: false });
        currDate = moment(currDate, 'DD/MM/yyyy').add(1, 'month').format('DD/MM/yyyy');
      }

      this.ordini.forEach((c, i) => {
        let totale = Utils.getNumberFromString(c.totale_ordine.includes(',') ? c.totale_ordine : c.totale_ordine + ',00');
        let dataOrdine = c.data_creazione.split(' ')[0].split('-').reverse().join('/');
        let dataPronto = c.data_pronto;
        let dataConsegna = c.data_consegna;

        let fatturazioni = JSON.parse(c.fatturazione);
        let provvigioni = JSON.parse(c.provvigioni);
        let pagamenti = JSON.parse(c.pagamento);
        let segnalatore = JSON.parse(c.segnalatore);

        dates.forEach(d => {
          this.ordini[i][d.id] = [0.0, 0.0, 0.0];
        })

        pagamenti.forEach(p => {
          let info = this.getDateInfo(totale, p, dataOrdine, dataPronto, dataConsegna);
          if (this.ordini[i][info.data]) {
            this.ordini[i][info.data][0] = this.ordini[i][info.data][0] ? (parseFloat(this.ordini[i][info.data][0]) + parseFloat(info.totale)).toFixed(2) : (parseFloat(info.totale).toFixed(2));
            ordiniMensiliSomma[parseInt(moment(info.data.replace('_', ' '), 'MMMM yy').format('MM')) - 1] = parseFloat(parseFloat(ordiniMensiliSomma[parseInt(moment(info.data.replace('_', ' '), 'MMMM yy').format('MM')) - 1]) + parseFloat(info.totale)).toFixed(2);
            ordiniEntrateSomma[parseInt(moment(info.data.replace('_', ' '), 'MMMM yy').format('MM')) - 1] = parseFloat(parseFloat(ordiniEntrateSomma[parseInt(moment(info.data.replace('_', ' '), 'MMMM yy').format('MM')) - 1]) + parseFloat(info.totale)).toFixed(2);
          }
        })

        provvigioni.forEach(p => {
          let info = this.getDateInfo(totale, p, dataOrdine, dataPronto, dataConsegna);
          if (this.ordini[i][info.data]) {
            this.ordini[i][info.data][1] = this.ordini[i][info.data][1] ? (parseFloat(this.ordini[i][info.data][1]) + parseFloat(info.totale)).toFixed(2) : (parseFloat(info.totale).toFixed(2));
            ordiniMensiliSomma[parseInt(moment(info.data.replace('_', ' '), 'MMMM yy').format('MM')) - 1] = parseFloat(parseFloat(ordiniMensiliSomma[parseInt(moment(info.data.replace('_', ' '), 'MMMM yy').format('MM')) - 1]) - parseFloat(info.totale)).toFixed(2);
            ordiniUsciteSomma[parseInt(moment(info.data.replace('_', ' '), 'MMMM yy').format('MM')) - 1] = parseFloat(parseFloat(ordiniUsciteSomma[parseInt(moment(info.data.replace('_', ' '), 'MMMM yy').format('MM')) - 1]) + parseFloat(info.totale)).toFixed(2);
          }
        })

        segnalatore.forEach(p => {
          let info = this.getDateInfo(totale, p, dataOrdine, dataPronto, dataConsegna);
          if (this.ordini[i][info.data]) {
            this.ordini[i][info.data][1] = this.ordini[i][info.data][1] ? (parseFloat(this.ordini[i][info.data][1]) + parseFloat(info.totale)).toFixed(2) : (parseFloat(info.totale).toFixed(2));
            ordiniMensiliSomma[parseInt(moment(info.data.replace('_', ' '), 'MMMM yy').format('MM')) - 1] = parseFloat(parseFloat(ordiniMensiliSomma[parseInt(moment(info.data.replace('_', ' '), 'MMMM yy').format('MM')) - 1]) - parseFloat(info.totale)).toFixed(2);
            ordiniUsciteSomma[parseInt(moment(info.data.replace('_', ' '), 'MMMM yy').format('MM')) - 1] = parseFloat(parseFloat(ordiniUsciteSomma[parseInt(moment(info.data.replace('_', ' '), 'MMMM yy').format('MM')) - 1]) + parseFloat(info.totale)).toFixed(2);
          }
        })

        fatturazioni.forEach(p => {
          let info = this.getDateInfo(totale, p, dataOrdine, dataPronto, dataConsegna);
          if (this.ordini[i][info.data]) {
            this.ordini[i][info.data][2] = this.ordini[i][info.data][2] ? (parseFloat(this.ordini[i][info.data][2]) + parseFloat(info.totale)).toFixed(2) : (parseFloat(info.totale).toFixed(2));
            ordiniFatturatoSomma[parseInt(moment(info.data.replace('_', ' '), 'MMMM yy').format('MM')) - 1] = parseFloat(parseFloat(ordiniFatturatoSomma[parseInt(moment(info.data.replace('_', ' '), 'MMMM yy').format('MM')) - 1]) + parseFloat(info.totale)).toFixed(2);
          }
        })

        dates.forEach(d => {

          let fatture = Utils.getNumberString(parseFloat(this.ordini[i][d.id][2]).toFixed(2));
          let entrate = Utils.getNumberString(parseFloat(this.ordini[i][d.id][0]).toFixed(2));
          let uscite = Utils.getNumberString(parseFloat(this.ordini[i][d.id][1]).toFixed(2));

          this.ordini[i][d.id] = 'F ' + fatture + '!-!-!I ' + entrate + '!-!-!P ' + uscite;
        })
      });

      var ordiniTotale = {
        'rif': 'Totale',
        'cliente': '',
      };

      dates.forEach((d, i) => {
        let fatture = Utils.getNumberString(parseFloat(ordiniFatturatoSomma[i]).toFixed(2));
        let entrate = Utils.getNumberString(parseFloat(ordiniEntrateSomma[i]).toFixed(2));
        let uscite = Utils.getNumberString(parseFloat(ordiniUsciteSomma[i]).toFixed(2));

        ordiniTotale[d.id] = 'F ' + fatture + '!-!-!I ' + entrate + '!-!-!P ' + uscite;
      })

      this.ordiniTotale = ordiniTotale;

      this.headCells = [
        ...this.headCells,
        ...dates,
        { id: '_', numeric: true, disablePadding: false, label: '' }
      ]
    }

    this.ordini.forEach((ordine, i) => {
      if (ordine.blocco === "1") {
        this.ordini[i].stato = 'Bloccata';
      } else if (ordine.conclusa === '1') {
        this.ordini[i].stato = 'Terminata';
      } else if (ordine.concluso_magazzino  === '1' && ordine.ddt_pdf !== null && JSON.parse(ordine.ddt_pdf).every((e) => e !== '')) {
        this.ordini[i].stato = 'Consegnato';
      } else if (ordine.is_parziale === '1') {
        this.ordini[i].stato = 'Parziale';
      } else if (ordine.approvata === '0') {
        this.ordini[i].stato = 'Inserito';
      } else if (ordine.approvata === '1' && ordine.link_conferma === null) {
        this.ordini[i].stato = 'Approvato';
      } else if (ordine.concluso_magazzino === '1') {
        this.ordini[i].stato = 'Concluso magazzino';
      } else {
        this.ordini[i].stato = 'In Corso';
      }

      this.ordini[i].totale_ordine = parseFloat(ordine.totale_ordine).toFixed(2) + ' €';

      if ((ordine.sopralluoghi === null || JSON.parse(ordine.sopralluoghi).length === 0) && ordine.concluso_tecnico === '0') {
        this.ordini[i].sopralluoghi = "Azione Richiesta";
      } else if ((ordine.sopralluoghi !== null) && ordine.concluso_tecnico === '0') {
        this.ordini[i].sopralluoghi = "In Corso";
      } else if (ordine.concluso_tecnico === '1') {
        this.ordini[i].sopralluoghi = "Concluso";
      }

      if (ordine.fuori_fido === '1') {
        this.ordini[i].icon = 'Fuori Fido';
      } else if (ordine.fuori_fido === '0' && ordine.aperto_cs === '0' && userType === 4) {
        this.ordini[i].icon = 'Non Aperto';
      } else if (ordine.conferma_magazzino === '1' && ordine.conferma_inviata === '0') {
        this.ordini[i].icon = 'Non Inviata';
      } else if (ordine.conferma_inviata === '1' && ordine.conferma_cliente === '0' && this.state.isUserType === 4) {
        this.ordini[i].icon = 'Non Confermata';
      } else if (ordine.conferma_cliente === '1' && ordine.link_ddt && !ordine.ddt_pdf) {
        this.ordini[i].icon = 'In consegna';
      } else if (ordine.is_parziale === '1' && ordine.concluso_magazzino === '0') {
        this.ordini[i].icon = 'Parziale'
      } else if (ordine.conclusa === '1') {
        this.ordini[i].icon = '';
      } else if (ordine.conferma_cliente === '1') {
        this.ordini[i].icon = 'Confermata';
      } else {
        this.ordini[i].icon = '';
      }

    });

    switch (userType) {
      case 0:
        OrdineLink = '/#/app/edit-ordine';
        break;
      case 1:
        OrdineLink = '/#/tecnico/edit-ordine';
        break;
      case 3:
        OrdineLink = '/#/commerciale/edit-ordine';
        break;
      case 4:
        OrdineLink = '/#/service/edit-ordine';
        break;
      default:
        break;
    }

    if (userType !== 0 && userType !== 3) {
      this.ordini = this.ordini.filter(ordine => ordine.approvata === '1')
    }

    if(userType === 4) {
      this.ordini = this.ordini.filter(ordine => ordine.seconda_approvazione === '1')
    }

    this.setState({ isLoading: false, isUserType: userType, ordineLink: OrdineLink });
  }

  async presaVisione(user, token, idOrdine) {
    const res = await editOrdineCsVisione(user, token, idOrdine);
    if (res.result === 'ok') {
      window.location.href = this.state.ordineLink;
    }
  }

  getDateInfo(totale, info, dataOrdine, dataPronto, dataConsegna) {

    let totaleSingolo = (totale * (parseFloat(info.percentage) / 100)).toFixed(2);
    var dataInfo = "";

    switch (info.from) {
      case "DO":
        dataInfo = moment(dataOrdine, 'DD/MM/yyyy').add(parseInt(info.days), 'days').format('MMMM yy').replace(' ', '_');
        break;
      case "DP":
        dataInfo = moment(dataPronto, 'DD/MM/yyyy').add(parseInt(info.days), 'days').format('MMMM yy').replace(' ', '_');
        break;
      case "DC":
        dataInfo = moment(dataConsegna, 'DD/MM/yyyy').add(parseInt(info.days), 'days').format('MMMM yy').replace(' ', '_');
        break;
      default:
        break;
    }

    return { data: dataInfo, totale: totaleSingolo };
  }

  async componentDidMount() {
    await this.reload();
  }

  async delete(row) {
    if (window.confirm('Sei davvero sicuro di volere eliminare quest\'ordine?')) {
      const res = await deleteOrdine(username, token, row);
      if (res.result === 'ok') {
        window.location.reload();
        return;
      }

      alert('Errore nella cancellazione dell\'ordine');
    }
  }


  render() {

    if (this.state.isLoading)
      return <Loading />;

    const cookies = new Cookies();

    this.searchCols = ['rif', 'ragione_sociale', 'data_creazione', 'stato'];

    if ((this.state.isUserType === 0 || this.state.isUserType === 4) && this.headCells.find(h => h.id === 'icon') === undefined) {
      this.headCells.unshift({ id: 'icon', disablePadding: false, label: '', icon: true, filter: false });
    }

    if (this.state.isUserType === 1 && this.headCells.find(h => h.id === 'sopralluoghi') === undefined) {
      this.headCells.push({ id: 'sopralluoghi', disablePadding: false, label: 'Stato Sopralluoghi', chip: true });
    }

    return (
      <div id={Math.random()}>

        {
          (this.state.isUserType !== 3) && <PageTitle title="Ordini" />
        }

        {
          this.state.isUserType === 3 && <PageTitle title="Ordini" button="CREA NUOVO" onClick={() => {
            this.props.history.push({
              pathname: '/commerciale/add-ordine',
              state: { is_preventivo: false }
            });
          }} />
        }

        <Table headCells={this.headCells} searchCols={this.searchCols} rows={this.ordini} order={'desc'} sortBy={(this.state.isUserType === 0 || this.state.isUserType === 4) ? 1 : 0}
          total={this.ordiniTotale}
          onEventClick={(row) => {
            cookies.set('ordine', row, { path: '/' });
            if (this.state.isUserType === 4) {
              this.presaVisione(username, token, row);
            }
            window.location.href = this.state.ordineLink;
          }}
          onDelete={this.state.isUserType == 0 ? this.delete.bind(this) : null}
        />
      </div>
    );
  }
}

